/*
 * Copyright (c) 2024-2026, s0up and the autobrr contributors.
 * SPDX-License-Identifier: GPL-2.0-or-later
 */

import { getApiUrl } from "@/utils/baseUrl";

export interface PveGuest {
  vmid: number;
  name: string;
  type: "qemu" | "lxc";
  node: string;
  status: string;
  cpu: number;
  mem: number;
  maxmem: number;
  uptime: number;
}

export interface PveGuests {
  configured: boolean;
  error?: string;
  guests: PveGuest[];
}

export type PveAction = "start" | "shutdown" | "reboot" | "stop";

export async function getPveGuests(): Promise<PveGuests> {
  const res = await fetch(getApiUrl("/proxmox/guests"), { credentials: "include" });
  if (!res.ok) throw new Error("Failed to load Proxmox guests");
  return res.json();
}

export async function pveAction(g: PveGuest, action: PveAction): Promise<void> {
  const res = await fetch(getApiUrl(`/proxmox/guests/${g.node}/${g.type}/${g.vmid}/${action}`), {
    method: "POST",
    credentials: "include",
  });
  if (!res.ok) throw new Error((await res.json().catch(() => ({})))?.error ?? "Action failed");
}
